export function setupReveals(reduced: MediaQueryList): () => void {
  const nodes = Array.from(document.querySelectorAll<HTMLElement>('[data-reveal], [data-stagger]'));
  const reveal = (node: HTMLElement) => {
    if (node.hasAttribute('data-reveal')) node.classList.add('is-revealed');
    if (node.hasAttribute('data-stagger')) node.classList.add('is-staggered');
  };
  if (reduced.matches) {
    nodes.forEach(reveal);
    return () => undefined;
  }
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      reveal(entry.target as HTMLElement);
      observer.unobserve(entry.target);
    }
  }, { rootMargin: '320px 0px 240px 0px', threshold: 0 });
  nodes.forEach((node) => observer.observe(node));
  return () => observer.disconnect();
}
